import React, { useState, useEffect } from "react";
import logo from "../imgs/Logo CodeSour.png";
import { Layout, Menu, Row, Col, Button } from "antd";
const { Content, Sider } = Layout;
const items = [
  {
    key: "table_campaigns",
    label: "Campaigns",
  },
  {
    key: "table_costumers",
    label: "Costumers",
  },
  {
    key: "table_leads",
    label: "Leads",
  },
  {
    key: "lead_controls",
    label: "Controllo Lead",
  },
];
function SiteWrapper({ children }) {
  const [logged, setLogged] = useState(false);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    const loggedStorage = localStorage.getItem("user");
    if (loggedStorage !== null) {
      setLogged(true);
      setDisabled(false);
    } else {
      window.location.assign("/login");
    }
  }, []);

  const onClick = (e) => {
    var key = e.key;
    key === "table_leads"
      ? window.location.assign("/table_leads")
      : key === "table_campaigns"
      ? window.location.assign("/table_campaigns")
      : key === "table_costumers"
      ? window.location.assign("/table_costumers")
      : key === "lead_controls"
      ? window.location.assign("/lead_control")
      : window.location.assign("/");
  };
  function logout() {
    localStorage.clear();
    setLogged(false);
    setLogged(true);
    window.location.replace("/");
  }

  const onClicks = (e) => {
    logged ? logout() : window.location.assign("/login");
  };

  return (
    <Layout hasSider>
      <Sider
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <img src={logo} alt="Logo" width="180px" style={{ margin: "10px" }} />
        <Menu
          theme="light"
          onClick={onClick}
          mode="inline"
          selectedKeys={window.location.pathname.split("/")[1]}
          items={items}
          disabled={disabled}
        />
        <div>
          <Button
            onClick={onClicks}
            type="primary"
            style={{
              position: "absolute",
              bottom: 10,
              marginLeft: 4,
              width: "94%",
            }}
          >
            {logged ? "logout" : "login"}
          </Button>
        </div>
      </Sider>
      <Layout
        style={{
          marginLeft: 190,
        }}
      >
        <Content
          style={{
            margin: "24px 16px 0",
            overflow: "initial",
          }}
        >
          <Row justify="space-between" style={{ height: "calc(100vh - 45px)" }}>
            <Col span={24}>{children}</Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
}
export default SiteWrapper;
